import { isNotDefined, getMACalculator, getSourcePathAccessor } from "../utils";

const defaultOptions = {
  windowSize: 14,
  sourcePath: "close",
  movingAverageType: "sma",
  standardDeviations: 2,
};

export default function () {
  let options = defaultOptions;

  function calculator(data) {
    const { windowSize, sourcePath, movingAverageType, standardDeviations } =
      options;

    const source = getSourcePathAccessor(sourcePath);

    // Step 1: Calculate moving average
    const maCalculator = getMACalculator(movingAverageType);
    const ma = maCalculator().options({ windowSize, sourcePath });
    const maValues = ma(data);

    // Step 2: Calculate standard deviation with rolling window
    const stdDevValues = [];
    let acc1 = 0; // sum of squared values
    let acc2 = 0; // sum of values

    for (let i = 0; i < data.length; i++) {
      const value = source(data[i]);

      if (isNotDefined(value)) {
        stdDevValues.push(undefined);
        continue;
      }

      // Add current value to accumulators
      acc1 += Math.pow(value, 2);
      acc2 += value;

      // Not enough data yet
      if (i < windowSize - 1) {
        stdDevValues.push(undefined);
        continue;
      }

      // Remove oldest value from rolling window
      if (i >= windowSize) {
        const oldValue = source(data[i - windowSize]);
        if (!isNotDefined(oldValue)) {
          acc1 -= Math.pow(oldValue, 2);
          acc2 -= oldValue;
        }
      }

      // Calculate standard deviation
      // Formula: sqrt((acc1 + n*MA² - 2*MA*acc2) / n)
      const maValue = maValues[i];

      if (isNotDefined(maValue)) {
        stdDevValues.push(undefined);
        continue;
      }

      const variance =
        (acc1 + windowSize * Math.pow(maValue, 2) - 2 * maValue * acc2) /
        windowSize;
      const stdDev = Math.sqrt(Math.max(0, variance)); // ensure non-negative for sqrt

      // Apply multiplier
      const result = stdDev * standardDeviations;

      stdDevValues.push(result);
    }

    return stdDevValues;
  }

  calculator.undefinedLength = function () {
    return options.windowSize - 1;
  };

  calculator.options = function (x) {
    if (!arguments.length) {
      return options;
    }
    options = { ...defaultOptions, ...x };
    return calculator;
  };

  return calculator;
}
